/** @format */
export enum PersonalizedLineAidTextString {
  NONE = 'None',
  STRAIGHT = 'StraightLine',
  TARGET = 'TargetLine',
}
